import React, { useState, forwardRef, useEffect } from "react";
import styles from "./TeamMembersList.module.css";
import { TeamMember } from "../types";
import { getTeamMembers } from "@/api/teamMemberApi";

export type TeamMembersListProps = {
  showDeactivate?: boolean;
  currentTeamSize?: number;
  maxTeamSize?: number;
  onDeactivate?: () => void | Promise<void>;
  demoUsers?: TeamMember[];
  onRowClick?: (user: TeamMember) => void;
  isEditing?: boolean;
  teamId?: string;
};

export type TeamMembersListRef = {
  refresh: () => Promise<void>;
};

const TeamMembersList = forwardRef<TeamMembersListRef, TeamMembersListProps>(
  (props) => {
    const { onRowClick, isEditing, teamId } = props;
    const [teamMembers, setTeamMembers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

      getTeamMembers(teamId)
        .then((nextCauses) => {
          setTeamMembers(nextCauses)
        })
        .catch((error) => {
          console.error("Failed to load team members:", error);
        });
      }, [teamId]);

    if (isLoading) {
      return <div className={styles.loading}>2 Loading team users...</div>;
    }

    const activeTeamMembers: any[] = teamMembers.filter(
      (user: any) =>
        user.status !== "deactivated" &&
        user.status !== "removed" &&
        user.status !== "invited" &&
        user.status !== "rejected" &&
        user.teamId === teamId
    );

    /*
    const deleteTeamMember = (memberId: string) => {
      setTeamMembers((prev: TeamMember[]) =>
        prev.filter((teamMember) => teamMember.id !== memberId)
      );
    };
     */

    return (
      <div className="select-component__duration-section">
        {activeTeamMembers.length > 0 &&
          activeTeamMembers.map((teamUser) => (
            <div key={teamUser.id}>
              <button
                type="button"
                className={`strength-button select-component__duration-button two-part-button ${styles.rowButton} ${onRowClick ? styles.clickable : ""}`}
                onClick={() => onRowClick?.(teamUser)}
              >
                <span>{teamUser.email}</span>
                {isEditing && (
                  <span
                    className={styles.removeIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      //deleteTeamMember(teamUser.id);
                    }}
                  >
                    x
                  </span>
                )}
              </button>
            </div>
          ))}
        {activeTeamMembers.length === 0 && <li>The team is empty</li>}
      </div>
    );
  }
);

export default TeamMembersList;
